module.exports = __webpack_public_path__ + "media/components/breadcrumbs/static/home-c81ccd7dd4af4dcd902f30b2cd632b60.png";